<template>
  <div id="travelTypesComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <b-alert :show="noDefault" variant="warning">
        <v-layout class="align-center">
          <v-flex class="mr-3">
            <v-icon class="alert-link">fa-exclamation-triangle</v-icon>
            <!-- <h3><i class="fas fa-exclamation-triangle"></i></h3> -->
          </v-flex>
          <v-flex>
            <h3 class="text-sm-justify"> {{$t('travelTypes.warning')}}</h3>
          </v-flex>
        </v-layout>
      </b-alert>
      <v-layout class="mb-2" wrap>
        <v-text-field
          v-model="TravelTypeSearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field>
        <v-spacer></v-spacer>
        <v-dialog persistent v-model="dialog" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              round
              outline
              v-on="on"
            >
              <v-icon
              left>fas fa-plane-departure</v-icon>
              {{ $t('travelTypes.add') }}
            </v-btn>
          </template>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{formTitle}}</h2>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-xs>
                <v-form
                  lazy-validation
                  ref="form"
                  v-model="valid"
                >
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          clearable
                          required
                          :rules="rules.textRules"
                          prepend-icon="edit"
                          :label="$t('travelTypes.description')"
                          :error-messages="errors.name"
                          v-model="editedItem.name"
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                round
                flat
                @click="close"
              >
                {{ $t('general.cancel') }}
              </v-btn>
              <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                round
                depressed
                @click="save"
              >
                {{ $t('general.save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-data-table
        :search="TravelTypeSearch"
        class="elevation-2"
        :headers="headers"
        :items="travelTypes"
        :loading="loadingItems"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination"
      >
      <template v-slot:headers="props">
        <tr class="bg-heavy-rain">
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
            >
            <h2 class="font-weight-black primary--text mb-0">
              <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
              {{ header.text }}
            </h2>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
          <tr>
              <td width="60px">{{props.item.id}}</td>
              <td class="text-sm-center"><v-icon style="vertical-align: middle" v-if="props.item.default === 1" class="info--text" >stars</v-icon>{{props.item.name}}</td>
              <td width="200px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="editItem(props.item)"
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.edit') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    outline
                    icon
                    color="error"
                    v-on="on"
                    @click="removed(props.item)"
                  >
                    <v-icon small>delete</v-icon>
                  </v-btn>
                  </template>
                  <span>{{ $t('general.delete') }}</span>
                </v-tooltip>
              </td>
          </tr>
      </template>
      </v-data-table>
      <v-dialog persistent v-model="removeDialog" max-width="600px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">{{ $t('travelTypes.delete') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('travelTypes.description') }}: </span>{{removedItem.name}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="removeItem(removedItem)"
            >
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faPlaneDeparture
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
library.add(
  faPlaneDeparture
)
export default {
  name: 'travelTypesComponent',
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  data () {
    return {
      TravelTypeSearch: '',
      noDefault: false,
      pagination: {
        descending: false,
        page: 0,
        rowsPerPage: 15,
        totalItems: 0
      },
      dialog: false,
      loading: false,
      loadingItems: true,
      removeDialog: false,
      valid: true,
      errors: {},
      editedIndex: -1,
      removedItem: {},
      originalItem: {},
      editedItem: {
        id: 0,
        name: ''
      },
      defaultItem: {
        id: 0,
        name: ''
      },
      travelTypes: []
    }
  },
  computed: {
    heading () {
      return this.$t('travelTypes.nameView')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fas fa-plane-departure fa-fw icon-color'
    },
    formTitle () {
      return this.editedIndex === -1 ? this.$t('travelTypes.new') : this.$t('travelTypes.edit')
    },
    headers () {
      return [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    rules () {
      return this.$validationRules()
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
    // categories () {
    //   if (this.categories.length > 0) {
    //     if (this.categories.find(item => item.default === 1)) {
    //       this.noDefault = false
    //     } else {
    //       this.noDefault = true
    //     }
    //   } else {
    //     this.noDefault = true
    //   }
    // }
  },
  created () {
    this.initialize()
  },
  methods: {
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    removed (item) {
      this.removedItem = item
      this.removeDialog = true
    },
    removeItem (item) {
      const index = this.travelTypes.indexOf(item)
      this.delete(item, index)
      this.loading = true
      // this.categories.splice(index, 1)
    },
    close () {
      this.dialog = false
      this.loading = false
      this.errors = {}
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.$refs.form.resetValidation()
    },
    closeRemove () {
      this.removeDialog = false
      this.loading = false
    },
    editItem (item) {
      this.editedIndex = this.travelTypes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    save () {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.put()
        } else {
          this.post()
        }
        this.loading = true
      }
    },
    initialize () {
      this.$emit('getTravelTypes', {context: this})
    },
    post () {
      this.$emit('postTravelType', {item: this.editedItem, context: this})
    },
    put () {
      this.$emit('putTravelType', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this
      }
      )
    },
    delete (item, index) {
      this.$emit('deleteTravelType', {
        item: item,
        index: index,
        context: this
      }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/travelTypes.component.vue